import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SidePanelService } from '@lib/services';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedBeneficiarySelectionComponent } from './shared-beneficiary-selection.component';

@NgModule({
    declarations: [SharedBeneficiarySelectionComponent],
    imports: [CommonModule, AngularMaterialModule, NgxMatIntlTelInputComponent, ReactiveFormsModule],
    providers: [SidePanelService],
    exports: [AngularMaterialModule, NgxMatIntlTelInputComponent, ReactiveFormsModule],
})
export class SharedBeneficiarySelectionModule {}
